export async function fetchQRData(monthKey) {
    const res = await fetch("https://amarraqrbucket.s3.us-east-1.amazonaws.com/qr-config.json");
    const allData = await res.json();
    return allData[monthKey];
  }
  